// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"fcd90240","155":"2cdee090","180":"0320d140","331":"2857507c","619":"d14cdc4d"}[chunkId] + ".chunk.js";
};